import useViewportSize from "./useViewportSize";

const MOBILE_BREAKPOINT_PX = 768;

const useIsMobile = () => {
  const { width } = useViewportSize();
  return width <= MOBILE_BREAKPOINT_PX;
};

export default useIsMobile;
